import { Tag, TagProps } from 'antd';
import { FC } from 'react';

const DgTag: FC<TagProps> = ({ children, ...props }) => {
	return <Tag {...props}>{children}</Tag>;
};

export default DgTag;
